
import {createContext, useState} from 'react'

const Context = createContext()

export const ServiciosHogarPlanesContextProvider = ({children}) => {
 const [allHogarPLanes, setAllHogarPlanes] = useState([])
 const [hogarPlanes, setHogarPlanes] = useState([]);
 const [hogarPlan, setHogarPlan] = useState({})
 const [loading, setLoading] = useState(false);
 const [message, setMessage] = useState({
  message: '',
  status: 200
 })


 return <Context.Provider value={{allHogarPLanes, setAllHogarPlanes, hogarPlanes, setHogarPlanes, hogarPlan, setHogarPlan, message, setMessage, loading, setLoading}}>
  {children}
 </Context.Provider>
}
export default Context